import { render, staticRenderFns } from "./KETHubgeraete.vue?vue&type=template&id=afb84700&scoped=true&"
import script from "./KETHubgeraete.vue?vue&type=script&lang=js&"
export * from "./KETHubgeraete.vue?vue&type=script&lang=js&"
import style0 from "./KETHubgeraete.vue?vue&type=style&index=0&id=afb84700&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb84700",
  null
  
)

export default component.exports